import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { QuestionIcon, WarningIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const SmartPropertyStatusQuestionIcon = () => {
  return /*#__PURE__*/_jsx(IconCircle, {
    backgroundColor: "fill-accent-red-default",
    color: "fill-surface-default",
    icon: QuestionIcon,
    padding: "25",
    size: "100",
    verticalAlign: "0"
  });
};
const SmartPropertyStatusWarningIcon = () => {
  return /*#__PURE__*/_jsx(IconHolder, {
    color: "fill-accent-red-default",
    icon: WarningIcon,
    marginBlock: "0",
    padding: "0",
    size: "400",
    verticalAlign: "-2px"
  });
};
export const getSmartPropertyRunStatusContent = ({
  error,
  status
}) => {
  if (status === 'COMPLETE_NO_RESULT') {
    return {
      icon: /*#__PURE__*/_jsx(SmartPropertyStatusQuestionIcon, {}),
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartPropertyStatus.noResultFound.bodyHeader"
      }),
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartPropertyStatus.noResultFound.body"
      })
    };
  }
  switch (error) {
    case 'GENERATIVE_AI_CUSTOMER_CONVERSATION_DISABLED':
      return {
        icon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.customerConversationDisabled.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.customerConversationDisabled.body"
        })
      };
    case 'NO_TRANSCRIPT_DATA':
      return {
        icon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.noTranscriptData.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.noTranscriptData.body"
        })
      };
    case 'OBJECT_NOT_FOUND':
      return {
        icon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.objectNotFound.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.objectNotFound.body"
        })
      };
    case 'INVALID_PROPERTY':
      return {
        icon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidProperty.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidProperty.body"
        })
      };
    case 'MISSING_PROPERTY_POINTER':
      return {
        icon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.missingPropertyPointer.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.missingPropertyPointer.body"
        })
      };
    case 'INVALID_PROPERTY_POINTER':
      return {
        icon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidPropertyPointer.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidPropertyPointer.body"
        })
      };
    case 'EMPTY_PROPERTY_POINTER':
      return {
        icon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.emptyPropertyPointer.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.emptyPropertyPointer.body"
        })
      };
    case 'INTERNAL_AGENT_ERROR':
    case 'INVALID_AGENT_RESULT':
    case 'CRM_WRITE_ERROR':
      return {
        icon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.internalAgentError.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.internalAgentError.body"
        })
      };
    case 'ENRICHMENT_DEADLINE_EXCEEDED':
      return {
        icon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.enrichmentDeadlineExceeded.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.enrichmentDeadlineExceeded.body"
        })
      };
    case 'INSUFFICIENT_CREDITS':
      return {
        icon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.insufficientCredits.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.insufficientCredits.body"
        })
      };
    case 'INVALID_DOMAIN':
      return {
        icon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidDomain.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidDomain.body"
        })
      };
    case 'INVALID_AGENT_RESULT_PII_DETECTED':
      return {
        icon: /*#__PURE__*/_jsx(SmartPropertyStatusQuestionIcon, {}),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidAgentResultPIIDetected.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.invalidAgentResultPIIDetected.body"
        })
      };
    default:
      return {
        icon: /*#__PURE__*/_jsx(SmartPropertyStatusWarningIcon, {}),
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.unknownError.bodyHeader"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartPropertyStatus.unknownError.body"
        })
      };
  }
};